import React, {useState} from 'react';

import {
  tabContainer,
  tabContainerListItem,
  tabContainerListItemActive,
} from '#Client/components/Tabs/Tabs.css';

type Props = {
  tabs: {
    title: string;
    content: React.ReactNode;
  }[];
};

export const Tabs = ({tabs}: Props) => {
  const [activeTabIndex, setActiveTabIndex] = useState<number>(0);

  return (
    <>
      <ul className={tabContainer}>
        {tabs.map((tab, index) => (
          <li
            className={`${tabContainerListItem} ${
              activeTabIndex === index ? tabContainerListItemActive : ''
            }`}
            key={tab.title}
            onClick={() => {
              setActiveTabIndex(index);
            }}
          >
            {tab.title}
          </li>
        ))}
      </ul>
      {tabs[activeTabIndex].content}
    </>
  );
};
